import roles from "@/roles";
export default [
  {
    icon: "perm_phone_msg",
    title: "Calls",
    roles: [roles.BETA_FEATURE, roles.ADMIN],
    children: [
      {
        icon: "settings_remote",
        router: true,
        title: "Manual Call Broadcast BETA",
        to: "ManualCallBroadcast",
        roles: [roles.BETA_FEATURE, roles.ADMIN]
      }
    ]
  }
];
